import ExpanderList from '@rio-cloud/rio-uikit/ExpanderList';
import { useState } from 'react';
import { useIntl } from 'react-intl';

import { TourStopProgress } from '#components/tourdetails/TourStopProgress.tsx';
import { TourStopProgressHeader } from '#components/tourdetails/TourStopProgressHeader.tsx';
import type { Driver } from '#domain/model/Driver.ts';
import type { Tour } from '#domain/model/Tour.ts';
import { getTourExpanderItems } from '#features/tours/sidebar/TourExpanderItems.tsx';

type TourDetailsSidebarProps = {
    tour: Tour;
    driver?: Driver;
    setSelectedStopId: (stopId?: string) => void;
};

export const TourDetails = ({ tour, driver, setSelectedStopId }: TourDetailsSidebarProps) => {
    const [selectedItemIndex, setSelectedItemIndex] = useState<number | undefined>(0);

    const intl = useIntl();

    const expanderItems = getTourExpanderItems({
        tour,
        selectedItemIndex,
        setSelectedItemIndex,
        setSelectedStopId,
    });

    return (
        <div data-testid='tour-details'>
            <div className='padding-x-15 padding-bottom-15'>
                <TourStopProgressHeader tour={tour} />
                {tour.status !== 'planned' && <TourStopProgress stops={tour.stops} />}
                {driver?.name && (
                    <div className='margin-top-5'>
                        {`${intl.formatMessage({ id: 'intl-msg:order-communication-web.livemonitor.driver' })}: ${driver.name}`}
                    </div>
                )}
                {tour.trailer.licensePlate && (
                    <div className='margin-top-5'>
                        {`${intl.formatMessage({ id: 'intl-msg:order-communication-web.livemonitor.trailer' })}: ${tour.trailer.licensePlate}`}
                    </div>
                )}
                <div className='margin-top-5'>{`${intl.formatMessage({ id: 'intl-msg:order-communication-web.livemonitor.tournote' })}: ${tour.note}`}</div>
            </div>
            <ExpanderList className='border border-left-none border-right-none' rounded={false} items={expanderItems} />
        </div>
    );
};
